import { compose } from 'ramda';

import { getCoworkingOfferTypeByOffer } from './getCoworkingOfferTypeByOffer';

export const getIsCoworkingByOffer = compose(Boolean, getCoworkingOfferTypeByOffer);
